module.exports = __webpack_public_path__ + "img/0102.d5e2279b.png";